import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./magzine.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  deleteVideo,
  //   getVideos,
  postVideoUpdate,
} from "../../../store/Action/videoAction";
import axios from "axios";
// import { deleteMagzine } from "../../../store/Action/magzineAction";
import Pagination from "../../../Pagination";
import moment from "moment";
// import MagazineSubscriberForm from "./MagazineSubscriberForm";
function SchoolMagazineSubscription() {
  const dispatch = useDispatch();
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  //   const [videos, setVideos] = useState([]);
  const [magazineForms, setMagazineForms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState("");
  const [showDetails, setShowDetails] = useState({});

  const [deletes, setDelete] = useState(1);
  const itemsPerPage = 12; // Change this to the desired number of items per page

  // Logic to calculate total pages
  // const queryParams = { page: currentPage, perPage: itemsPerPage };

  // Fetch categories and total count from API or any data source
  useEffect(() => {
    const fetchMagzine = async () => {
      try {
        const response = await axios.get(`${apiUrl}newmagzineform/get-all-submissions?page=${currentPage}&perPage=${itemsPerPage}`);
        if (response) {
             setMagazineForms(response.data.submissions);
        setTotalPage(response.data.totalPages);
          //   console.log(response, "mag
          // azine subscribers");
        //   setMagazineForms(response?.data?.data); // Update with the correct field name from your API response
          // console.log(response, "magazine subscribers");
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchMagzine();
  }, [dispatch, currentPage, deletes]);

//   const nextPage = () => {
//     if (magazineForms.length === itemsPerPage) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const prevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
//   const handleDelete = (categoryId) => {
//     if (window.confirm("Are you sure you want to delete this category?")) {
//       const response = dispatch(deleteMagzine(categoryId));
//       if (response) {
//         setDelete(response);
//       }
//     }
//   };
  // console.log(magazineForms, "maga");
const nextPage = () => {
  if (currentPage < totalPage) {
    setCurrentPage((prev) => prev + 1);
  }
};

const prevPage = () => {
  if (currentPage > 1) {
    setCurrentPage((prev) => prev - 1);
  }
};
  return (
    <div className="manage-category">
      <div className="card magazine-subscriber">
        <div className="card-header">Manage Magzine</div>
        <div className="card-body">
            <div className="d-flex justify-content-end mb-3">
    <button
      className="btn btn-success"
      onClick={() => {
        window.open(`${apiUrl}newmagzineform/export`, "_blank");
      }}
    >
      Export as Excel
    </button>
  </div>

          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">School Name</th>
                <th scope="col">Plan per year</th>
                <th scope="col">Contact No.</th>
                <th scope="col">E mail</th>
                {/* <th scope="col">End Date</th> */}
                <th scope="col">Address</th>
                <th scope="col">status</th>
                {/* <th scope="col">View Details</th> */}
              </tr>
            </thead>
          <tbody>
  {magazineForms?.map((item) => {
    let addressObj = {};
    try {
      addressObj = JSON.parse(item.address || '{}');
    } catch {}

    return (
      <tr key={item._id}>
        <td><b>{item.schoolname}</b></td>
        <td>{item.plan}</td>
        <td>{item.mobile}</td>
        <td>{item.email}</td>
        {/* <td>{moment(item.subscriptionStartDate).add(item.plan, "years").format("DD-MM-YYYY")}</td> */}
        <td>
          {addressObj.address}, {addressObj.city}, {addressObj.state}, {addressObj.pincode}
        </td>
        <td>{item.subscriptionStatus}</td>
      </tr>
    );
  })}
</tbody>

          </table>
        <div className="card-footer bg-transparent border-secondary d-flex justify-content-center">
  <div className="pagination">
    <button
      className="pagination-btn"
      onClick={prevPage}
      disabled={currentPage === 1}
    >
      Previous
    </button>
    <span className="current-page">Page {currentPage} of {totalPage}</span>
    <button
      className="pagination-btn"
      onClick={nextPage}
      disabled={currentPage >= totalPage}
    >
      Next
    </button>
  </div>
</div>

        </div>
      </div>
    </div>
  );
}

export default SchoolMagazineSubscription;
